import * as React from 'react';
import { SpinnerOverlay } from '@weddingspot/ws-core-components';
import { CheckoutContext, Steps } from './utils/CheckoutContext';

import { Button } from '@cvent/carina/components/Button';

const styles = require('./CheckOutPage.module.scss');
const SpinnerProps = {
    spinnerColor: '#881155',
    spinnerDiameter: 40,
};

const CheckOutButtons = () => {
    const { confirmButtonAction, confirmButtonName, secondaryButtonName, secondaryButtonAction, isRequested, step, isConfirmDisabled } =
        React.useContext(CheckoutContext);

    return (
        <div className={styles.buttons}>
            {step !== Steps.Final && (
                <button className={styles.cancel} type='button' onClick={secondaryButtonAction} disabled={isRequested}>
                    {secondaryButtonName}
                </button>
            )}
            <SpinnerOverlay spinnerProps={SpinnerProps} isSpinning={isRequested}>
                <Button text={confirmButtonName} appearance='filled' onClick={confirmButtonAction} disabled={isConfirmDisabled} />
            </SpinnerOverlay>
        </div>
    );
};

export default CheckOutButtons;
